var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"social",staticClass:"social"},[_c('ul',[_c('li',[_c('Facebook')],1),_c('li',[_c('Twitter')],1),_c('li',[_c('Pinterest')],1),_c('li',[_c('Linkedin')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }